import React, { useState, useEffect, useRef } from 'react';
import ShowInformation from './subs/ShowInformation';
import { Editor } from '@tinymce/tinymce-react';
import {
  Grid, Table, TableContainer, Tab, Box, Typograph, TextField,
  Paper, TableCell, TableBody, TableRow, Typography, Autocomplete,
  Button, Modal, TableHead, Alert, FormControlLabel,
  Switch, IconButton, Fab
} from '@mui/material';
import { useSelector, useDispatch } from "react-redux";
import { setCargaDatos } from "../Redux/V2/ContratoRedux";
import {
  getConsentimiento, ReplaceTagsConsentimiento, descargarPdf, ReplaceTagsContrato
} from "../Redux/V2/TagsRedux";
import { setCargaDatosFirma, resetActionFirma } from "../Redux/V2/FirmaRedux";
import { setCargaGeneral, getTemplateContratos } from "../Redux/GeneralDuck";
import { TabContext, TabList, TabPanel } from '@mui/lab';
import Swal from 'sweetalert2';

import { Send, CloudDownload, DeleteForever, Close, HourglassTopTwoTone, KeyboardArrowUp } from '@mui/icons-material';

import CloudUploadIcon from '@mui/icons-material/CloudUpload';

import Cookies from 'universal-cookie'

import { styleModalFirma } from './styles/modal'

import { VisuallyHiddenInput } from '../components/VisualyHiddenInput';
import { SkipNext } from '@mui/icons-material';
import { CloudUpload } from 'react-bootstrap-icons';

const formatter = new Intl.NumberFormat("es-CL"); // formato CLP (Chile)


const Contrato = ({ from, onChangeSave }) => {
  const dispatch = useDispatch();
  const [valueTab, setValueTab] = useState("1");
  const [consentimientoDescargado, setConsentimientoDescargado] = useState(0);
  const [fechaDescarga, setfechaDescarga] = useState(0);
  const [templateActive, setTemplateActive] = useState({})
  const [modalFirma, setModalFirma] = useState(false)
  const [checkedGD, setCheckedGD] = useState(true);
  const [emailPagador, setEmailPagador] = useState(/*pagador?.email ?? */'');
  const [disabledComponent, setDisabledComponent] = useState(false);
  const [enviandoFirma, setEnviandoFirma] = useState(false);
  const [recuperandoFirma, setRecuperandoFirma] = useState(false);
  const [visibleFab, setVisibleFab] = useState(false);

  const inputFileRef = useRef(null);

  const entrevista = useSelector((store) => store.contratoV2.Entrevista);
  const contrato = useSelector((store) => store.contratoV2.contrato); // servicios contratados
  const consentimiento = useSelector((store) => store.contratoV2.Consentimiento);
  const templateContratos = useSelector((store) => store.general.templateContratos);
  const documento = useSelector((store) => store.contratoV2.Documento);
  const pagador = useSelector((store) => store.contratoV2.Pagador);
  const defendido = useSelector((store) => store.contratoV2.Defendido);
  const firma = useSelector((store) => store.firmaV2.ElectronicSignature);
  const actualizacion = useSelector((store) => store.contratoV2.Actualizacion);
  const cuotas = useSelector((store) => store.contratoV2.Cuotas);

  // 🔒 flags globales de bloqueo por estado del contrato
  const contratoCancelado = useSelector((store) => store.contratoV2.ContratoCancelado);
  const contratoFiniquitado = useSelector((store) => store.contratoV2.ContratoFiniquitado);
  const contratoFirmado = useSelector((store) => store.contratoV2.ContratoFirmado);

  // seleccionado actual según lo que tengas guardado
  const selectedTemplate = React.useMemo(() => {
    if (!Array.isArray(templateContratos)) return null;
    return templateContratos.find(t => t.id === templateActive?.layoutId) || null;
  }, [templateContratos, templateActive?.layoutId]);


  const cookies = new Cookies();
  const userRolId = parseInt(cookies.get('rolId')) ?? 0;

  const bloqueadoTotalmente =
    !!contratoCancelado?.cancelado ||
    !!contratoFiniquitado?.finiquitado || (contratoFirmado?.firmado && !disabledComponent)


  useEffect(() => {
    const handleScroll = () => {
      setVisibleFab(window.scrollY > 300);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };


  useEffect(() => {
    if (actualizacion?.actualizacion?.status == 1) //si es actualizacion en curso
      setDisabledComponent(true)
  }, [actualizacion]);


  useEffect(() => {
    if (entrevista.id) {
      dispatch(setCargaDatos("Documento", "get", entrevista.id))
      dispatch(setCargaDatos("contrato", "get", entrevista.contractId));
      dispatch(getTemplateContratos(entrevista.lineaNegocioId));
      dispatch(setCargaDatos("Defendido", "get", entrevista.id))
      dispatch(setCargaDatos('Pagador', 'get', entrevista.id));
      dispatch(setCargaDatos('ContratoFirmado', 'get', entrevista.id));
      dispatch(setCargaDatos("Cuotas", "get", entrevista.id));
      dispatch(setCargaDatosFirma("ElectronicSignature", "patch", "", entrevista.contractId));
      console.log("contrato, useEffect de entrevista")
    }
  }, [entrevista.id])

  useEffect(() => {
    setEmailPagador(pagador?.email ?? '');
  }, [pagador]);

  useEffect(() => {
    if (documento) {
      setTemplateActive(documento)
    }
  }, [documento])

  useEffect(() => {
    if (consentimientoDescargado > 0 && consentimiento?.dateGet != fechaDescarga) { // revis
      setConsentimientoDescargado(0)
      setfechaDescarga(consentimiento.dateGet)
      var html = dispatch(ReplaceTagsConsentimiento(consentimiento.layoutContent))
      dispatch(descargarPdf(html, "Consentimiento"))
    }
  }, [consentimientoDescargado, consentimiento])

  const handleUpdatePagadorEmail = async () => {
    if (bloqueadoTotalmente) return; // 🔒
    pagador.email = emailPagador;
    //dispatch(setCargaDatos("Pagador", "put", { ...pagador, email: emailPagador }));
    await dispatch(setCargaDatos('ContratoFirmado', 'get', entrevista.id));
  };

  const getConsentimiento = async (idService) => {
    if (bloqueadoTotalmente) return; // 🔒
    var sfireHB = Swal.fire({
      title: 'Descargando consentimiento...',
      allowOutsideClick: false,
      didOpen: () => { Swal.showLoading(); }
    })
    var exito = await dispatch(setCargaDatos("Consentimiento", "get", idService))
    if (exito)
      setConsentimientoDescargado(consentimientoDescargado + 1)
    sfireHB.close()
  }

  const handlePrepararTemplate = async (value) => {

    if (bloqueadoTotalmente) return; // 🔒
    if (!value) return;
    if (value.id == templateActive.layoutId && templateActive.layoutId != 0) {
      return
    }
    else if (templateActive?.layoutId > 0 && value.id != templateActive.layoutId) {
      const result = await Swal.fire({
        title: 'Esta cambiando el template del contrato',
        text: 'El contrato anterior se borrará y perderá las modificaciones realizadas ¿Deseas continuar con esta acción?',
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: 'Sí, continuar',
        cancelButtonText: 'Cancelar',
      });
      if (!result.isConfirmed) return;
    }
    setTemplateActive({
      ...documento,
      id: 0,
      layoutId: value.id,
      html: value.html,
      name: value.name,
    })
  }

  const handleConfirmReview = async () => {
    if (bloqueadoTotalmente) return; // 🔒
    if (templateActive.layoutId == null || templateActive.layoutId == 0) {
      Swal.fire({ icon: "warning", title: "Contrato no seleccionado" });
      return;
    }
    else if (documento?.layoutId !== 0 && documento?.html !== templateActive.html) {
      const result = await Swal.fire({
        title: 'Está cambiando el template del contrato',
        text: 'Se está guardando una modificiación del contrato. El anterior se borrará permanentemente ¿Deseas continuar con esta acción?',
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: 'Sí, continuar',
        cancelButtonText: 'Cancelar',
      });
      if (!result.isConfirmed) return;
    }
    var payload = { ...templateActive }
    payload.InterviewId = entrevista.id
    dispatch(setCargaDatos("Documento", "post", payload))
  }

  const handleFirma = async (type) => {
    if (bloqueadoTotalmente || enviandoFirma) return;

    if (templateActive.layoutId == null || templateActive.layoutId == 0) {
      Swal.fire({ icon: "warning", title: "Contrato no seleccionado" });
      return;
    }
    
    const fecha = parseFechaLocal(cuotas.fechaPago);
    const hoy = new Date();
    hoy.setHours(0, 0, 0, 0);
    fecha.setHours(0, 0, 0, 0);
    if (fecha < hoy) {
      const result = await Swal.fire({
        title: 'La Fecha de pago del contrato es menor a hoy',
        text: '¿Deseas continuar con el proceso de firma con la fecha anterior a la de hoy?',
        icon: 'Warning',
        showCancelButton: true,
        confirmButtonText: 'Sí, continuar',
        cancelButtonText: 'No, cancelar',
      });

      if (!result.isConfirmed){
        return
      }
    }

    setEnviandoFirma(true);
    try {
      if (type === "GD") {
        handleUpdatePagadorEmail();
        await dispatch(setCargaDatosFirma("ElectronicSignature", "post", "GrupoDefensa", { ContractId: entrevista.contractId, EmailSign: pagador?.email, SignatureType: checkedGD ? 12 : 13 }))
      }
      if (type === "MAN") {
        await dispatch(setCargaDatosFirma("ElectronicSignature", "post", "Manual", { ContractId: entrevista.contractId }))
      }
    } catch (error) {
      console.error("Error al enviar la firma:", error);
    } finally {
      setEnviandoFirma(false);
    }
    await dispatch(setCargaDatos("Entrevista", "get", entrevista.id))
    await dispatch(setCargaDatos('ContratoFirmado', 'get', entrevista.id))
    await dispatch(setCargaDatos("Documento", "get", entrevista.id))
    await dispatch(setCargaDatos("contrato", "get", entrevista.contractId))
    await dispatch(getTemplateContratos(entrevista.lineaNegocioId))
    await dispatch(setCargaDatosFirma("ElectronicSignature", "patch", "", entrevista.contractId))
  }

  const checkFirma = async (type, file) => {
    setRecuperandoFirma(true)
    if (bloqueadoTotalmente) return; // 🔒
    if (templateActive.layoutId == null || templateActive.layoutId == 0) {
      Swal.fire({ icon: "warning", title: "Contrato no seleccionado" });
      setRecuperandoFirma(false)
      return;
    }

    const fecha = parseFechaLocal(cuotas.fechaPago);
    const hoy = new Date();
    hoy.setHours(0, 0, 0, 0);
    fecha.setHours(0, 0, 0, 0);
    if (fecha < hoy) {
      const result = await Swal.fire({
        title: 'El contrato tiene una fecha de pago menor a hoy',
        text: '¿Deseas continuar el contrato con la fecha de pago anterior a la de hoy?',
        icon: 'Warning',
        showCancelButton: true,
        confirmButtonText: 'Sí, continuar',
        cancelButtonText: 'No, cancelar',
      });

      if (!result.isConfirmed){
        setRecuperandoFirma(false)
        return
      }
    }
    
    let success = false;
    if (type === "GD") {
      success = await dispatch(setCargaDatosFirma("ElectronicSignature", "get", "GrupoDefensa", { ContractId: entrevista.contractId }));
    }

    if (type === "MAN") {
      success = await dispatch(setCargaDatosFirma("ElectronicSignature", "put", "Manual", { ContractId: entrevista.contractId, Archivo: file }));
    }
    await dispatch(setCargaDatos("Entrevista", "get", entrevista.id))
    await dispatch(setCargaDatos('ContratoFirmado', 'get', entrevista.id))
    await dispatch(setCargaDatos("Documento", "get", entrevista.id))
    await dispatch(setCargaDatos("contrato", "get", entrevista.contractId))
    await dispatch(getTemplateContratos(entrevista.lineaNegocioId))
    await dispatch(setCargaDatosFirma("ElectronicSignature", "patch", "", entrevista.contractId))

    setRecuperandoFirma(false)
    //if (success) {
    //  Swal.fire({ icon: "success", title: "Contrato firmado" });
    //}
  }

  const deleteFirma = async (type) => {
    setRecuperandoFirma(true)
    if (bloqueadoTotalmente) return; // 🔒
    if (templateActive.layoutId == null || templateActive.layoutId == 0) {
      Swal.fire({ icon: "warning", title: "Contrato no seleccionado" });
      return;
    }

    if (type === "GD")
      await dispatch(setCargaDatosFirma("ElectronicSignature", "delete", "GrupoDefensa", { ContractId: entrevista.contractId }))
    if (type === "MAN")
      await dispatch(setCargaDatosFirma("ElectronicSignature", "delete", "Manual", { ContractId: entrevista.contractId }))


    await dispatch(setCargaDatos("Entrevista", "get", entrevista.id))
    await dispatch(setCargaDatos('ContratoFirmado', 'get', entrevista.id))
    await dispatch(setCargaDatos("Documento", "get", entrevista.id))
    await dispatch(setCargaDatos("contrato", "get", entrevista.contractId))
    await dispatch(getTemplateContratos(entrevista.lineaNegocioId))
    await dispatch(setCargaDatosFirma("ElectronicSignature", "patch", "", entrevista.contractId))
    setRecuperandoFirma(false)
  }



  const StatusAlert = ({ status }) => {
    switch (status) {
      case "Pendiente":
        return <Alert severity="warning">{status}</Alert>;
      case "Firmado":
        return <Alert severity="success">{status}</Alert>;
      case "No Enviado":
        return <Alert severity="info">{status}</Alert>;
      default:
        return <Alert severity="info">No Firmado</Alert>;
    }
  };

  const parseFechaLocal = (yyyyMMdd) => {
    const [year, month, day] = yyyyMMdd.split("-").map(Number);
    return new Date(year, month - 1, day); // ← esto usa hora local
  }

  return (
    <div style={{ padding: "20px" }}>
      <ShowInformation from={from} />
      <Grid container className='p-2' justifyContent="flex-end" alignItems="center">
        <Grid item>
          {documento?.layoutId !== 0 && documento?.html == templateActive?.html ?
            <Button variant="contained" color="primary" onClick={() => setModalFirma(true)} disabled={disabledComponent || bloqueadoTotalmente /* 🔒 */}> firmar </Button>
            :
            <Alert severity="warning">Confirme la revision del contrato</Alert>
          }
        </Grid>
        <br></br>
      </Grid>
      {/* CONSENTIMIENTOS */}
      <TableContainer component={Paper} sx={{ marginBottom: 2 }}>
        <Table>
          <TableBody>
            {contrato?.map((servicio, index) => (
              <TableRow key={index}>
                <TableCell>{servicio.name}</TableCell>
                <TableCell >$ {formatter.format(servicio.monto)} </TableCell>
                <TableCell align="right"> <Button disabled={true || disabledComponent || bloqueadoTotalmente /* 🔒 */} onClick={() => getConsentimiento(servicio.idService)} variant="contained" color="success"> Cons. no disponible</Button></TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>

      </TableContainer>
      <TableContainer component={Paper} sx={{ marginBottom: 2 }}>
        <Grid container spacing={2} className='mb-2 mt-2'>
          {/* SELECCION DE CONTRATO*/}
          <Table>
            <TableBody>
              <TableRow>
                <TableCell className='w-25'><Typography className='m-3' variant="subtitle1" >Contrato Seleccionado:</Typography></TableCell>
                <TableCell className='w-75'>
                  <Autocomplete
                    options={Array.isArray(templateContratos) ? templateContratos : []}
                    getOptionLabel={(option) => option?.name ?? ""}
                    isOptionEqualToValue={(option, value) => option.id === value.id}
                    value={selectedTemplate}                     // <<— valor controlado
                    onChange={(event, newValue) => handlePrepararTemplate(newValue)}
                    renderInput={(params) => (
                      <TextField {...params} label="Seleccione Contrato" />
                    )}
                    disablePortal
                    disabled={disabledComponent || bloqueadoTotalmente}
                  />

                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </Grid>
        {/* CONTRATO EDITABLE */}
        <TabContext value={valueTab}>
          <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <TabList onChange={(event, newValue) => setValueTab(newValue)}>
              <Tab label="Editar Contrato" value="1" />
              <Tab label="Ver Contrato" value="2" />
            </TabList>
          </Box>
          <TabPanel value="1">
            <Editor
              tinymceScriptSrc='/tinymce/tinymce.min.js'
              licenseKey='GPL'
              //apiKey="no89skh86yibdbm71do29mqz4ldjyv6h6ix52vctyv798ztf"
              value={templateActive.html ?? ""}
              onEditorChange={(text) => {
                if (bloqueadoTotalmente) return; // 🔒
                setTemplateActive((prev) => ({ ...prev, html: text }))
              }}
              disabled={disabledComponent || bloqueadoTotalmente /* 🔒 */}
              init={{
                height: 500,
                menubar: true,
                plugins: [
                  'advlist', 'autolink', 'lists', 'link', 'image', 'charmap', 'preview',
                  'anchor', 'searchreplace', 'visualblocks', 'code', 'fullscreen',
                  'insertdatetime', 'media', 'table', 'code', 'help', 'wordcount'
                ],
                toolbar: 'undo redo | blocks | ' +
                  'bold italic forecolor | alignleft aligncenter ' +
                  'alignright alignjustify | bullist numlist outdent indent | ' +
                  'removeformat | help',
                branding: false
              }}
            />
          </TabPanel>
          <TabPanel value="2">
            <Typography
              className='p-5'
              component="div"
              dangerouslySetInnerHTML={{ __html: dispatch(ReplaceTagsContrato(templateActive.html ?? "")) }}
            />
          </TabPanel>

          <Grid container className='p-2' justifyContent="flex-end" alignItems="center">
            <Grid item>

              {bloqueadoTotalmente || bloqueadoTotalmente ? (
                <Button
                  type="button"
                  variant="contained"
                  color="success"
                  startIcon={<SkipNext />}
                  size="large"
                  onClick={() => onChangeSave(4)}
                >
                  Continuar
                </Button>
              ) : (

                <Button
                  variant="contained"
                  color="primary" onClick={handleConfirmReview}
                >  confirmar revision
                </Button>
              )}

            </Grid>
          </Grid>
        </TabContext>
      </TableContainer>
      {/* <Grid container className='p-2' justifyContent="flex-end" alignItems="center">
        <Grid item>
          <Button variant="contained" color="primary" onClick={{handleSubmit}}> Siguiente </Button>
        </Grid>
      </Grid> */}

      <Modal
        open={modalFirma}
        onClose={() => setModalFirma(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={styleModalFirma}>
          <IconButton
            aria-label="close"
            onClick={() => setModalFirma(false)}
            sx={{ position: 'absolute', top: 8, right: 8 }}
          >
            <Close />
          </IconButton>
          <Typography sx={{ mb: 2 }} variant="h6" component="h2">
            Enviar Contrato a:
            <TextField
              sx={{ mt: 2 }}
              fullWidth
              label="Correo electrónico"
              type="email"
              required
              value={emailPagador}
              onChange={e => setEmailPagador(e.target.value)}
              InputLabelProps={{ shrink: true }}
              disabled={bloqueadoTotalmente /* 🔒 */}
            />
          </Typography>
          <Typography sx={{ mb: 2 }} variant="h6" component="h2">
            Firmar Via:
          </Typography>
          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
            <TableContainer component={Paper}>
              <Table aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <TableCell>Modo Firma</TableCell>
                    <TableCell align="right">Enviar</TableCell>
                    <TableCell align="right">Revisar</TableCell>
                    <TableCell align="right">Cancelar</TableCell>
                    <TableCell align="right">Estado</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                </TableBody>
                <TableBody>
                  <TableRow>
                    <TableCell component="th" scope="row">FIRMA GD</TableCell>
                    <TableCell align="right">
                      <FormControlLabel hidden={firma["grupoDefensa"]?.estado != "No Enviado"}
                        control={
                          <Switch
                            checked={checkedGD}
                            onChange={(event) => { if (!bloqueadoTotalmente) setCheckedGD(event.target.checked); }} // 🔒
                            color="warning"
                            disabled={bloqueadoTotalmente}
                          />
                        }
                        label={checkedGD ? 'con Firma' : 'con Codigo'}
                      />
                      <Button onClick={() => handleFirma("GD")} color="success" variant="text" hidden={firma["grupoDefensa"]?.estado !== "No Enviado"}
                        disabled={bloqueadoTotalmente || enviandoFirma}>
                        {enviandoFirma ? <HourglassTopTwoTone /> : <Send />}
                      </Button>
                    </TableCell>
                    <TableCell align="right">
                      <Button onClick={() => checkFirma("GD")} color="info" variant="text" hidden={firma["grupoDefensa"]?.estado != "Pendiente"}
                        disabled={bloqueadoTotalmente || recuperandoFirma || userRolId == 3}>
                        {recuperandoFirma ? <HourglassTopTwoTone /> : <CloudDownload />}</Button>
                    </TableCell>
                    <TableCell align="right">
                      <Button onClick={() => deleteFirma("GD")} color="error" variant="text" hidden={firma["grupoDefensa"]?.estado != "Pendiente"} disabled={bloqueadoTotalmente || recuperandoFirma || userRolId == 3}>
                        {recuperandoFirma ? <HourglassTopTwoTone /> : <DeleteForever />}</Button></TableCell>
                    <TableCell align="right">
                      <StatusAlert status={firma["grupoDefensa"]?.estado} />
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell component="th" scope="row">MANUAL</TableCell>
                    <TableCell align="right">
                      <Button onClick={() => handleFirma("MAN")} color="success" variant="text" hidden={firma["manual"]?.estado != "No Enviado"}
                        disabled={bloqueadoTotalmente || enviandoFirma}>
                        {enviandoFirma ? <HourglassTopTwoTone /> : <Send />}
                      </Button>
                    </TableCell>
                    <TableCell align="right">
                      <Button
                        color="info"
                        variant="text"
                        onClick={() => !bloqueadoTotalmente && inputFileRef.current && inputFileRef.current.click()} // 🔒
                        hidden={firma["manual"]?.estado != "Pendiente"}
                        disabled={bloqueadoTotalmente || recuperandoFirma || userRolId == 3}
                      >
                        {recuperandoFirma ? <HourglassTopTwoTone /> : <>
                          <CloudUploadIcon fontSize="medium" />
                          <VisuallyHiddenInput
                            type="file"
                            ref={inputFileRef}
                            onChange={(event) => checkFirma("MAN", event.target.files)}
                            multiple
                            style={{ display: 'none' }}
                          /></>
                        }
                      </Button>
                    </TableCell>
                    <TableCell align="right">
                      <Button onClick={() => deleteFirma("MAN")} color="error" variant="text" hidden={firma["manual"]?.estado != "Pendiente"} disabled={bloqueadoTotalmente || recuperandoFirma || userRolId == 3}>
                        {recuperandoFirma ? <HourglassTopTwoTone /> : <DeleteForever />}</Button></TableCell>
                    <TableCell align="right">
                      <StatusAlert status={firma["manual"]?.estado} />
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </Typography>
        </Box>
      </Modal>
      {visibleFab && (
        <Fab
          color="primary"
          onClick={scrollToTop}
          style={{
            position: 'fixed',
            bottom: 16,
            right: 16,
            zIndex: 1000,
          }}
        >
          <KeyboardArrowUp />
        </Fab>
      )}
    </div>
  );
};

export default Contrato;
